import { useEffect, useState } from 'react';

import SDK from '../services/sdk';

const useProject = (projectId: string) => {
  const [project, setProject] = useState<{
    folderFullPathEnabled?: boolean;
    projectId: string;
  }>({
    projectId
  });

  useEffect(() => {
    const loadProject = async () => {
      try {
        const projectInfo = await SDK.Projects.getProject(projectId);
        setProject({
          projectId: projectInfo.id,
          folderFullPathEnabled: projectInfo.folderFullPathEnabled
        });
      } catch (ex) {
        // Once failed, default to no show full path
        setProject({ projectId, folderFullPathEnabled: false });
        console.error('Failed to load project info!', ex);
      }
    };

    if (projectId) loadProject();
  }, [projectId]);

  return project;
};

export { useProject };
